import { Link, useLocation, useNavigate } from "react-router-dom";
import "./dashboard.css";
import { useEffect, useState } from "react";
import axios from "axios";
import VerificationComponent from "./verification/verification";
import DashboardBuy from "./dashboardBuySell/DashboardBuy";
import Transaction from "./transaction/transaction";
import BankInformation from "./bankInformation/bankInformation";
import Setting from "./setting/setting";
import { baseUrl } from "../../enum/constant";
import UserList from "./admin/UserList";
import RequestFormList from "./admin/RequestFormList";
import BuyAllList from "./admin/BuyAllList";
import UserView from "./admin/UserView";
import SellAllList from "./admin/SellAllList";
import AddBank from "./admin/bank/AddBank";
import CommissionRateManager from "./admin/CommissionRateManager";

const DashboardComponent = ({
  role,
  onLogoutClick,
  setIsDashboardNavbar,
  setNavText,
  navText,
  setUserEmail,
}) => {
  const location = useLocation();

  const { from, amount, to, amountType, transactionType } =
    location.state ||
    JSON.parse(localStorage.getItem("pendingTransaction") || "{}");

  const [status, setStatus] = useState("");
  const [reloadStatus, setReloadStatus] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // To store selected user ID
  const [selectedCurrency, setSelectedCurrency] = useState(null); // Manage selected currency
  const [activeTab, setActiveTab] = useState(""); // To store selected user ID
  const [activeImg, setActiveImg] = useState(""); // To store selected user ID

  const usercrId = localStorage.getItem("userId");

  const navigate = useNavigate();

  useEffect(() => {
    setIsDashboardNavbar(true);
    setNavText(role == "admin" ? "All Users" : "Buy | Sell");
    setActiveTab(role == "admin" ? "tab11" : "tab1");
    setActiveImg(
      role == "admin"
        ? "images/Group_4226_7e84fe170a.svg"
        : "assets/images/buy-sell-tab.p+ng"
    );
    if (usercrId) {
      getUserStatus();
    }

    return () => {
      setIsDashboardNavbar(false);
      setNavText("");
      setActiveTab("");
    };
  }, [usercrId]);

  useEffect(() => {
    getUserStatus();
  }, [reloadStatus]);

  const getUserStatus = async () => {
    try {
      const base = baseUrl;
      const res = await axios.get(`${base}api/current-status/${usercrId}`);
      if (res.data.success) {
        setStatus(res.data.data.status);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleLogout = () => {
    onLogoutClick();
    setTimeout(() => {
      navigate("/home");
    }, 10);
  };

  const handleMenuChange = (txt, id, img) => {
    // Set navigation text
    setNavText(txt);
    setActiveTab(id);
    if (id == "tab15") {
      setSelectedCurrency(null); // Reset the currency state when switching to Add Bank tab
    }
    setActiveImg(img);
    if (id == "tab11") {
      setSelectedUserId(null);
    }
    document.getElementById("dropdownMenu").classList.remove("show");
  };

  const handleViewUser = (userId) => {
    const selectedElem = document.getElementById("tab17");
    if (selectedElem) {
      const elem = document.getElementById("tab11");
      if (elem) {
        elem.classList.remove("active", "show");
      }
      selectedElem.classList.add("active", "show");
    }
    setSelectedUserId(userId);
  };

  return (
    <>
      <div className="dashboard-parent">
        <section className="hearo-wrap hero-inner desh-board ">
          <div className="container hero-bx padding-top-bot">
            <div className="row justify-content-center">
              <div className="col-md-12">
                {status && role !== "admin" && status !== "Approved" && (
                  <div className="verifection-box">
                    <div className="box">
                      <div className="left-box">
                        <img
                          className="mob-hide"
                          src="assets/images/check-mark1.png"
                        />
                        <div className="text-box">
                          <h4>
                            <img
                              src="assets/images/check-mark1.png"
                              className="mob-show"
                            />{" "}
                            Complete Your Verification{" "}
                          </h4>
                          <p>
                            Verify your identity to unlock full access to fast
                            and secure crypto exchanges. It only takes a few
                            minutes!
                          </p>
                        </div>
                      </div>

                      <div className="btn-part">
                        <a
                          href="#"
                          className="btn buy-btn verify-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#verificationModal"
                        >
                          Verify Now
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="tab-section">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-lg-3">
                <div className="tab-box">
                  <div
                    className="nav flex-column nav-pills gap-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    {role === "admin" && (
                      <>
                        <button
                          onClick={() => {
                            handleMenuChange(
                              "All Users",
                              "tab11",
                              "images/Group_4226_7e84fe170a.svg"
                            );
                            setSelectedUserId(null);
                          }}
                          className="nav-link admin-nav-btn active"
                          id="tab11-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab11"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img
                              src="images/Group_4226_7e84fe170a.svg"
                              alt=""
                            />
                          </span>
                          All Users
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "All Enquirys",
                              "tab12",
                              "images/Group_4226_7e84fe170a.svg"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab12-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab12"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img src="images/Group_4226_7e84fe170a.svg" />
                          </span>
                          All Enquirys
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Buy Transaction",
                              "tab13",
                              "images/menu-history-icon.svg"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab13-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab13"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img src="images/menu-history-icon.svg" alt="" />
                          </span>
                          Buy Transaction
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Sell Transaction",
                              "tab14",
                              "images/menu-history-icon.svg"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab14-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab14"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img src="images/menu-history-icon.svg" alt="" />
                          </span>
                          Sell Transaction
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Add Bank Details",
                              "tab15",
                              "images/Group_4226_7e84fe170a.svg"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab15-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab15"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img
                              src="images/Group_4226_7e84fe170a.svg"
                              alt=""
                            />
                          </span>
                          Add Bank Details
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Set Range",
                              "tab16",
                              "images/menu-aml-check-icon.svg"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab16-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab16"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img src="images/menu-aml-check-icon.svg" alt="" />
                          </span>
                          Set Range
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Settings",
                              "tab4",
                              "images/menu-settings-icon.png"
                            )
                          }
                          className="nav-link admin-nav-btn"
                          id="tab4-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab4"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span>
                            <img src="images/menu-settings-icon.png" alt="" />
                          </span>
                          Settings
                        </button>
                        <button
                          className="nav-link admin-nav-btn"
                          id="tab5-tab"
                          data-bs-toggle="modal"
                          data-bs-target="#logoutModal"
                        >
                          <span
                            className="bg-secondary p-1"
                            style={{ borderRadius: "3px" }}
                          >
                            <img src="assets/images/log-out-tab.png" alt="" />
                          </span>
                          Log Out
                        </button>
                      </>
                    )}
                    {role === "user" && (
                      <>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Buy | Sell",
                              "tab1",
                              "assets/images/buy-sell-tab.png"
                            )
                          }
                          className="nav-link active"
                          id="tab1-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab1"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span className="icon">
                            <img src="assets/images/buy-sell-tab.png" alt="" />
                          </span>
                          Buy | Sell
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Check Transaction",
                              "tab2",
                              "assets/images/clock-tab.png"
                            )
                          }
                          className="nav-link"
                          id="tab2-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab2"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span className="icon">
                            <img src="assets/images/clock-tab.png" />
                          </span>
                          Check Transaction
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Bank Information",
                              "tab3",
                              "assets/images/bank-tab.png"
                            )
                          }
                          className="nav-link"
                          id="tab3-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab3"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span className="icon">
                            <img src="assets/images/bank-tab.png" alt="" />
                          </span>
                          Bank Information
                        </button>
                        <button
                          onClick={() =>
                            handleMenuChange(
                              "Settings",
                              "tab4",
                              "assets/images/setting-tab.png"
                            )
                          }
                          className="nav-link"
                          id="tab4-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#tab4"
                          type="button"
                          role="tab"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <span className="icon">
                            <img src="assets/images/setting-tab.png" alt="" />
                          </span>
                          Settings
                        </button>
                        <button
                          className="logout-popup nav-link"
                          id="tab5-tab"
                          data-bs-toggle="modal"
                          data-bs-target="#logoutModal"
                        >
                          <span
                            className={
                              role === "user" ? "icon" : "admin-logout icon"
                            }
                          >
                            <img src="assets/images/log-out-tab.png" alt="" />
                          </span>
                          Log Out
                        </button>
                      </>
                    )}
                  </div>
                </div>
                {/* <!-- mobile layout--> */}
                <div className="mobile-tab-dropdown d-md-none">
                  <button
                    className="dropdown-toggle-tab"
                    onClick={() =>
                      document
                        .getElementById("dropdownMenu")
                        .classList.toggle("show")
                    }
                    id="dropdownToggle"
                  >
                    <span className="selected-text" id="selectedTabText">
                      <span className={role === "user" ? "icon" : ""}>
                        <img
                          src={activeImg || "assets/images/buy-sell-tab.png"}
                          alt=""
                        />
                      </span>{" "}
                      &nbsp; {navText}
                    </span>
                  </button>

                  <ul className="dropdown-tab-menu" id="dropdownMenu">
                    {role === "admin" && (
                      <>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "All Users",
                              "tab11",
                              "images/Group_4226_7e84fe170a.svg"
                            )
                          }
                          data-target="#tab11"
                          data-text="All Users"
                        >
                          <span className="mx-2">
                            <img
                              src="images/Group_4226_7e84fe170a.svg"
                              alt=""
                            />
                          </span>{" "}
                          All Users
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "All Enquirys",
                              "tab12",
                              "images/Group_4226_7e84fe170a.svg"
                            )
                          }
                          data-target="#tab12"
                          data-text="All Enquirys"
                        >
                          <span className="mx-2">
                            <img
                              src="images/Group_4226_7e84fe170a.svg"
                              alt=""
                            />
                          </span>{" "}
                          All Enquirys
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Buy Transaction",
                              "tab13",
                              "images/menu-history-icon.svg"
                            )
                          }
                          data-target="#tab13"
                          data-text="Buy Transaction"
                        >
                          <span className="mx-2">
                            <img src="images/menu-history-icon.svg" alt="" />
                          </span>{" "}
                          Buy Transaction
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Sell Transaction",
                              "tab14",
                              "images/menu-history-icon.svg"
                            )
                          }
                          data-target="#tab14"
                          data-text="Sell Transaction"
                        >
                          <span className="mx-2">
                            <img src="images/menu-history-icon.svg" alt="" />
                          </span>{" "}
                          Sell Transaction
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Add Bank Details",
                              "tab15",
                              "images/Group_4226_7e84fe170a.svg"
                            )
                          }
                          data-target="#tab15"
                          data-text="Add Bank Details"
                        >
                          <span className="mx-2">
                            <img
                              src="images/Group_4226_7e84fe170a.svg"
                              alt=""
                            />
                          </span>{" "}
                          Add Bank Details
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Set Range",
                              "tab16",
                              "images/menu-aml-check-icon.svg"
                            )
                          }
                          data-target="#tab16"
                          data-text="Set Range"
                        >
                          <span className="mx-2">
                            <img src="images/menu-aml-check-icon.svg" alt="" />
                          </span>{" "}
                          Set Range
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Settings",
                              "tab4",
                              "images/menu-settings-icon.png"
                            )
                          }
                          data-target="#tab4"
                          data-text="Settings"
                        >
                          <span className="mx-2">
                            <img src="images/menu-settings-icon.png" alt="" />
                          </span>{" "}
                          Settings
                        </li>
                        <li
                          data-bs-toggle="modal"
                          data-bs-target="#logoutModal"
                        >
                          <span
                            className="bg-secondary p-1 mx-2"
                            style={{ borderRadius: "3px" }}
                          >
                            <img src="assets/images/log-out-tab.png" alt="" />
                          </span>{" "}
                          Log Out
                        </li>
                      </>
                    )}
                    {role === "user" && (
                      <>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Buy | Sell",
                              "tab1",
                              "assets/images/buy-sell-tab.png"
                            )
                          }
                          data-target="#tab1"
                          data-text="Buy | Sell"
                        >
                          <span className="icon">
                            <img src="assets/images/buy-sell-tab.png" alt="" />
                          </span>{" "}
                          Buy | Sell
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Check Transaction",
                              "tab2",
                              "assets/images/clock-tab.png"
                            )
                          }
                          data-target="#tab2"
                          data-text="Check Transaction"
                        >
                          <span className="icon">
                            <img src="assets/images/clock-tab.png" alt="" />
                          </span>{" "}
                          Check Transaction
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Bank Information",
                              "tab3",
                              "assets/images/bank-tab.png"
                            )
                          }
                          data-target="#tab3"
                          data-text="Bank Information"
                        >
                          <span className="icon">
                            <img src="assets/images/bank-tab.png" alt="" />
                          </span>{" "}
                          Bank Information
                        </li>
                        <li
                          onClick={() =>
                            handleMenuChange(
                              "Settings",
                              "tab4",
                              "assets/images/setting-tab.png"
                            )
                          }
                          data-target="#tab4"
                          data-text="Settings"
                        >
                          <span className="icon">
                            <img src={"assets/images/setting-tab.png"} alt="" />
                          </span>{" "}
                          Settings
                        </li>
                        <li
                          className="logout-popup"
                          data-bs-toggle="modal"
                          data-bs-target="#logoutModal"
                          data-text="Log Out"
                        >
                          <span
                            className={
                              role === "user"
                                ? "icon"
                                : "admin-logout icon mx-2"
                            }
                          >
                            <img src="assets/images/log-out-tab.png" alt="" />
                          </span>{" "}
                          Log Out
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>

              <div className="col-md-9 col-lg-9 cus-col-9-div">
                <div className="tab-content" id="v-pills-tabContent">
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab1" ? " active show" : "")
                    }
                    id="tab1"
                    role="tabpanel"
                    aria-labelledby="tab1-tab"
                  >
                    {activeTab == "tab1" && (
                      <DashboardBuy
                        status={status}
                        trData={{
                          from,
                          amount,
                          to,
                          amountType,
                          transactionType,
                        }}
                      />
                    )}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab2" ? " active show" : "")
                    }
                    id="tab2"
                    role="tabpanel"
                    aria-labelledby="tab2-tab"
                  >
                    {activeTab == "tab2" && <Transaction />}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab3" ? " active show" : "")
                    }
                    id="tab3"
                    role="tabpanel"
                    aria-labelledby="tab3-tab"
                  >
                    {activeTab == "tab3" && <BankInformation />}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab4" ? " active show" : "")
                    }
                    id="tab4"
                    role="tabpanel"
                    aria-labelledby="tab4-tab"
                  >
                    {activeTab == "tab4" && (
                      <Setting setUserEmail={setUserEmail} role={role} />
                    )}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab11" ? " active show" : "")
                    }
                    id="tab11"
                    role="tabpanel"
                    aria-labelledby="tab11-tab"
                  >
                    {activeTab == "tab11" && selectedUserId ? (
                      <UserView userId={selectedUserId} />
                    ) : (
                      activeTab == "tab11" && (
                        <UserList onViewUser={handleViewUser} />
                      )
                    )}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab12" ? " active show" : "")
                    }
                    id="tab12"
                    role="tabpanel"
                    aria-labelledby="tab12-tab"
                  >
                    {activeTab == "tab12" && <RequestFormList />}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab13" ? " active show" : "")
                    }
                    id="tab13"
                    role="tabpanel"
                    aria-labelledby="tab13-tab"
                  >
                    {activeTab == "tab13" && <BuyAllList />}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab14" ? " active show" : "")
                    }
                    id="tab14"
                    role="tabpanel"
                    aria-labelledby="tab14-tab"
                  >
                    {activeTab == "tab14" && <SellAllList />}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab15" ? " active show" : "")
                    }
                    id="tab15"
                    role="tabpanel"
                    aria-labelledby="tab15-tab"
                  >
                    {activeTab == "tab15" && (
                      <AddBank
                        resetCurrency={setSelectedCurrency}
                        selectedCurrency={selectedCurrency}
                      />
                    )}
                  </div>
                  <div
                    className={
                      "tab-pane fade" +
                      (activeTab == "tab16" ? " active show" : "")
                    }
                    id="tab16"
                    role="tabpanel"
                    aria-labelledby="tab16-tab"
                  >
                    {activeTab == "tab16" && <CommissionRateManager />}
                  </div>

                  {/* logout modal */}
                  <div
                    className="modal fade"
                    id="logoutModal"
                    tabindex="-1"
                    aria-labelledby="logoutModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content logout-modal-content">
                        <div className="modal-body text-center px-4 py-4">
                          <button
                            type="button"
                            className="btn-close float-end"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <img src="assets/images/cross.png" />
                          </button>
                          <h5 className="fw-bold mb-3">Confirm log out</h5>
                          <p className="text-muted mb-4">
                            &nbsp; Logging out will end your current session.
                            You’ll need to sign in again to access your
                            dashboard, transaction history, and other features.
                            Make sure all your actions are completed before
                            exiting.
                          </p>
                          <div className="d-flex justify-content-center gap-3">
                            <button
                              onClick={handleLogout}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              className="btn btn-primary px-4 py-2 cus-btn-hover-affect"
                            >
                              Log out
                            </button>
                            <button
                              className="btn btn-outline-danger px-4 py-2"
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* verification modal */}
                  <div
                    className="modal fade"
                    id="verificationModal"
                    tabindex="-1"
                    aria-labelledby="verificationModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content logout-modal-content">
                        <div className="modal-body text-center px-4 py-4">
                          <button
                            type="button"
                            className="btn-close float-end"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <img src="assets/images/cross.png" />
                          </button>
                          <VerificationComponent
                            updateStatus={setReloadStatus}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default DashboardComponent;
